import { copyDashboard, makeDashboard } from 'src/dashboard/store/utils/dashboard'
import { createObject } from 'src/utils/objects'

const Getters = {
  setDefaultMetricSettings(state) {
    const { metricGroupByMap, metricTypeMap } = state
    return (endpointKey, dashboard) => {
      const getDefaultMetricType = () => metricTypeMap[endpointKey][0].value
      const getDefaultMetricGroupBy = () => metricGroupByMap[endpointKey][0].value
      const metricGroupBy = getDefaultMetricGroupBy()
      const metricType = getDefaultMetricType()

      dashboard.metricGroupBy = metricGroupBy
      dashboard.metricType = metricType

      return dashboard
    }
  },
  haveDashboardSettings(state, getters, rootState, rootGetters) {
    const dashboardSettings = rootGetters['auth/dashboardSettings']
    const hasDefinedDashboardSettings = !!dashboardSettings && typeof dashboardSettings === 'object' && !Array.isArray(dashboardSettings)
    return hasDefinedDashboardSettings && !!Object.keys(dashboardSettings).length
  },
  dashboardData(state, getters, rootState, rootGetters) {
    const { haveDashboardSettings, setDefaultMetricSettings } = getters
    const dashboardSettings = rootGetters['auth/dashboardSettings']
    const teamsByReportCode = rootGetters['tools/teamsByReportCode']
    const reportCodes = Object.keys(teamsByReportCode)

    const getReportOptions = (reportCode) => {
      const reportOptionsByReportCode = rootGetters['tools/reportOptionsByReportCode']
      const reports = reportOptionsByReportCode[reportCode]
      const excludedEndpoints = ['custom-analytics', 'organization', 'person', 'project']
      return reports.filter((report) => excludedEndpoints.indexOf(report.baseReportName) === -1)
    }
    const makeDashboardSetting = (reportCode) => {
      const dashboardSeed = teamsByReportCode[reportCode]
      const reportOptions = getReportOptions(reportCode)
      const isMissingMetricSettings = (dashboard) => !dashboard.metricType || !dashboard.metricGroupBy

      return reportOptions.map((report, index) => {
        const { baseReportName, reportPath, routeName } = report
        const dashboard = copyDashboard(dashboardSeed, index)
        const endpointKey = baseReportName || routeName

        dashboard.baseReportName = baseReportName
        dashboard.reportPath = reportPath
        dashboard.routeName = routeName

        if (isMissingMetricSettings(dashboard)) {
          setDefaultMetricSettings(endpointKey, dashboard)
        }

        return dashboard
      })
    }
    const makeDefaultSettings = () => reportCodes.reduce((dashboardsByReportCode, reportCode) => {
      dashboardsByReportCode[reportCode] = makeDashboardSetting(reportCode)
      return dashboardsByReportCode
    }, {})
    const useDashboardSettings = () => reportCodes.reduce((dashboardsByReportCode, reportCode) => {
      const dashboardSettingsForNetwork = dashboardSettings[reportCode] || makeDashboardSetting(reportCode)
      dashboardsByReportCode[reportCode] = dashboardSettingsForNetwork.sort((a, b) => a.index - b.index)
      return dashboardsByReportCode
    }, {})

    return haveDashboardSettings ? useDashboardSettings() : makeDefaultSettings()
  },
  dashboardsByReportCode(state, getters, rootState, rootGetters) {
    const { dashboardData } = getters
    const { searchResults } = rootState.tools
    const findSearchOption = rootGetters['tools/findSearchOption']
    const getSearchOptions = rootGetters['tools/getSearchOptions']
    const reportCodes = Object.keys(dashboardData)

    return reportCodes.reduce((dashboardsByReportCode, reportCode) => {
      const networkDashboards = dashboardData[reportCode]

      dashboardsByReportCode[reportCode] = networkDashboards.map((networkDashboard) => {
        const { associationId, baseReportName, index, reportPath, routeName, subId } = networkDashboard
        const navKey = baseReportName || routeName
        const searchOptions = navKey && getSearchOptions(navKey, searchResults)
        const searchOption = searchOptions && findSearchOption(searchOptions, associationId, baseReportName, reportPath, routeName, subId)

        const { reportLabel } = searchOption || {}
        const overwrites = { index, reportLabel }

        return createObject(networkDashboard, overwrites)
      })

      return dashboardsByReportCode
    }, {})
  },
  currentReportCode(state, getters, rootState, rootGetters) {
    const { associationId, subId } = rootGetters['tools/associationIdAndSubId']
    return `${associationId}/${subId}`
  },
  dashboards(state, getters) {
    const { currentReportCode, dashboardsByReportCode } = getters
    const dashboards = dashboardsByReportCode[currentReportCode] || []
    return dashboards.sort((a, b) => a.index - b.index) || []
  },
  emptyDashboardCard(state, getters) {
    const { dashboards } = getters
    return makeDashboard(dashboards.length)
  },
}

export default Getters
